<template>
  <div class="grid">
    <div class="col-12 md:col-12">
      <transition-group name="p-messages" tag="div">
        <Message v-for="msg of messages" :severity="msg.severity" :key="msg.content">{{ msg.content }}</Message>
      </transition-group>
    </div>
    <Toast />

    <TabView v-if="temInscricoes" class="col-12 md:col-12">
      <TabPanel header="Últimas inscrições">
          <div v-for="inscricao of inscricoesEmAndamento" v-bind:key="inscricao.identificador">
            <CardMinhaInscricao :inscricao="inscricao">
              <template #footer>
                <div class="field grid" v-if="temPendencia(inscricao.estadoInscricao, inscricao.id.selecaoEstagio)">
                  <Button label="Reenviar documentos" icon="pi pi-refresh"
                      class="p-button-warning" style="width: 200px" @click="openReenviar(inscricao)"/>
                </div>

                <ReenviarDocumento v-if="inscricao != undefined" :reenviarDialog.sync="reenviarDialog" :paramInscricao="inscricao" :paramProcesso="inscricao.id.selecaoEstagio"
                                    :onCarregarDadoUsuario="buscarIncricoesUsuario" :mensagemErro.sync="messages"/>

                <div class="field grid" v-if="exibirCartaoConfirmacao(inscricao.estadoInscricao, inscricao.id.selecaoEstagio)">
                  <Button label="Cartão de confirmação" icon="pi pi-print" style="width: 200px" @click="printCartao(inscricao.identificador)"/>
                </div>

                <div class="field grid" v-if="podeCancelar(inscricao.id.selecaoEstagio)">

                  <Button id="btn_cancelar" label="Cancelar inscrição" icon="pi pi-trash" class="p-button-danger" style="width: 200px" @click="openConfirmation"/>

                  <Dialog header="Cancelar inscrição" :visible.sync="displayConfirmation" :style="{ width: '350px' }" :modal="true">
                    <div class="confirmation-content">
                      <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem"/>
                      <span> Você tem certeza que deseja CANCELAR sua inscrição no processo de seleção? </span>
                    </div>

                    <template #footer>
                      <Button id="btn_sim" label="Sim" icon="pi pi-check" @click="cancelarInscricao(inscricao.identificador)"
                        class="p-button-text"/>
                      <Button id="btn_nao" label="Não" icon="pi pi-times" @click="closeConfirmation"
                        class="p-button-text"/>
                    </template>
                  </Dialog>
                </div>
              </template>

            </CardMinhaInscricao>
          </div>
      </TabPanel>

      <TabPanel header="Inscrições Anteriores" v-if="temInscricoesAnteriores">
        <Accordion>
          <AccordionTab v-for="inscricao in inscricoesFinalizadas"
            :key="inscricao.identificador" :header="inscricao.id.selecaoEstagio.nome" :active="true">
            <CardMinhaInscricao :inscricao="inscricao"></CardMinhaInscricao>
          </AccordionTab>
        </Accordion>
      </TabPanel>
    </TabView>

    <Panel header="Minhas inscrições" v-else class="col-12 md:col-12">
      <p class="p-error">Você não tem inscrições em processos seletivos!</p>
      <div class="field col-2">
        <router-link :to="{ name: 'processo.em.andamento' }">
          <Button
            label="Ver processo seletivo em aberto"
            style="width:220px"
          ></Button>
        </router-link>
      </div>
    </Panel>

  </div>
</template>

<script>
import http from "@/http";
import CardMinhaInscricao from "../components/CardMinhaInscricao.vue";
import InscricaoService from "../service/InscricaoService";
import ReenviarDocumento from "./ReenviarDocumento.vue";

import { tratamentoDeErros } from "@/tratamentoDeErros";

export default {
  components: {
    CardMinhaInscricao: CardMinhaInscricao, ReenviarDocumento
  },

  mixins: [tratamentoDeErros],

  data() {
    return {
      messages: [],
      messagesReenvio: [],
      displayConfirmation: false,
      mensagemErro: "",
      ultimaInscricao: null,
      inscricoes: [],
      temInscricoes: false,
      temInscricoesAnteriores: false,
      submitted: false,
      reenviarDialog: false,
      selectedFileLaudo: null,
      selectedFileRg: null,
      selectedFileMatricula: null,
      selectedFileHistorico: null,
      idDocumentoReenvio: null,
      id_inscricao: null,
      usuario: {
        id: 0,
        nome: "",
        sexo: "",
        cpf: "",
        data_nascimento: "",
        rg: "",
        email: "",
        enderecos: [
          {
            logradouro: "",
            numero: "",
            complemento: "",
            bairro: "",
            cep: "",
            cidade: {
              nome: "",
              estado: {
                uf: "",
                nome: "",
              },
            },
          },
        ],
        celular: [""],
      },
      disabled: true,
      inscricaoService: null,
      inscricoesEmAndamento: null,
      inscricoesFinalizadas: null,
    };
  },
  mounted() {
    this.inscricaoService = new InscricaoService();

    var url = `usuario/${this.$store.state.usuario}`;
    // console.log("url request: " + url);
    http
      .get(url)
      .then((resposta) => {
        this.usuario = resposta.data;
      })
      .catch((erro) => {
        console.log("Erro status: " + erro.request.status);
      });

    //preencher inscricoes usuarios
    this.buscarIncricoesUsuario();
  },

  methods: {
    printCartao(identificador) {
      // console.log("Imprimir cartão");
      this.$store.state.dlgLoading = true;
      var url = `inscricao/export/pdf/${identificador}`;

      console.log(`url: ${url}`);

      http({
        url: url,
        method: "GET",
        responseType: "blob",
      })
        .then((reponse) => {
          const fileBlob = new Blob([reponse.data]);

          const fileUrl = window.URL.createObjectURL(fileBlob);

          const fileLink = document.createElement("a");
          fileLink.href = fileUrl;

          fileLink.setAttribute("download", "Cartão de confirmação.pdf");
          document.body.appendChild(fileLink);

          fileLink.click();
          this.$store.state.dlgLoading = false;
        })
        .catch((erro) => {
          this.messages = [
            { severity: "error", content: `Ocorreu um erro: ${erro}` },
          ];
          console.log(erro);
          this.$store.state.dlgLoading = false;
        });
    },

    exibirCartaoConfirmacao(estadoInscricao, selecaoEstagio) {
      console.log("exibirCartaoConfirmacao: ", estadoInscricao, selecaoEstagio.exibirCartaoConfirmacao);
     return estadoInscricao.inscricaoConfirmada && selecaoEstagio.exibirCartaoConfirmacao;
     // return estadoInscricao.inscricaoConfirmada && true;
    },

    temPendencia(estadoInscricao, selecaoEstagio) {
      // console.log('Estado Inscricao', estadoInscricao.inscricaoComPendencia);
      return selecaoEstagio.abertoParaInscricao && estadoInscricao.inscricaoComPendencia && !selecaoEstagio.analiseDocumental;
    },

    hideDialogReenviar() {
      this.reenviarDialog = false;
      this.submitted = false;
    },

    podeCancelar(processoSeletivo) {
      return this.inscricoesEmAberto(processoSeletivo);
    },

    async cancelarInscricao(identificador) {
      var url = `inscricao/${identificador}`;

      await http.delete(url).then(() => {
        this.buscarIncricoesUsuario();
        this.closeConfirmation();
      });
    },

    download(identificador, tituloArquivo) {
      var url = `inscricao/download/${identificador}`;
      this.$store.state.dlgLoading = true;

      http({
        url: url,
        method: "GET",
        responseType: "blob",
      }).then((reponse) => {
        const fileBlob = new Blob([reponse.data]);

        const fileUrl = window.URL.createObjectURL(fileBlob);

        const fileLink = document.createElement("a");
        fileLink.href = fileUrl;

        tituloArquivo += ".pdf";
        fileLink.setAttribute("download", tituloArquivo);
        document.body.appendChild(fileLink);

        fileLink.click();
        this.$store.state.dlgLoading = false;
      });
    },

    open() {
      this.display = true;
    },
    close() {
      this.display = false;
    },
    openConfirmation() {
      this.displayConfirmation = true;
    },
    closeConfirmation() {
      this.displayConfirmation = false;
    },

    openReenviar(inscricao) {
      this.submitted = false;
      this.reenviarDialog = true;
      this.inscricao = inscricao;

      this.messagesReenvio = [];
      this.selectedFileLaudo = null;
      this.selectedFileRg = null;
      this.selectedFileMatricula = null;
      this.selectedFileHistorico = null;
    },

    inscricoesEmAberto(processoSeletivo) {
      return processoSeletivo.abertoParaInscricao;
    },

    isTipoPDF(elementById) {
      var fileUpload = document.getElementById(elementById);
      if (!fileUpload.value.endsWith(".pdf")) {
        this.messagesReenvio = [
          {
            severity: "error",
            content: "Somente arquivos do tipo *.pdf são permitidos",
          },
        ];
        return false;
      }
      return true;
    },

    async reenviar() {
      if (this.selectedFileLaudo) {
        console.log("reenviar comprovante_deficiencia");
        await this.updateDocumento(
          "comprovante_red_escolar",
          this.inscricao.id.usuario.comprovante_deficiencia.id,
          this.selectedFileLaudo
        );
      }

      if (this.selectedFileRg) {
        console.log("reenviar comprovante_rg");
        await this.updateDocumento(
          "comprovante_red_escolar",
          this.inscricao.id.usuario.comprovante_rg.id,
          this.selectedFileRg
        );
      }

      if (this.selectedFileMatricula) {
        console.log("reenviar comprovante_mat");
        await this.updateDocumento(
          "comprovante_red_escolar",
          this.inscricao.comprovanteMatriculaId,
          this.selectedFileMatricula
        );
      }

      if (this.selectedFileHistorico) {
        console.log("reenviar comprovante_red_escolar");
        await this.updateDocumento(
          "comprovante_red_escolar",
          this.inscricao.comprovanteHistoricoEscolaId,
          this.selectedFileHistorico
        );
      }

      this.hideDialogReenviar();
      this.buscarIncricoesUsuario();
    },
    onMensagemSucesso(mensagem, tempo) {
      this.$toast.add({
                            severity: "success",
                            summary: "Sucesso",
                            detail: `Teste`,
                            life: 3000,
                          });
      this.$toast.add({
          severity: "success", summary: "Sucesso", detail: mensagem,life: tempo,
        });
    },

    buscarIncricoesUsuario() {
      this.inscricoesEmAndamento = [];
      this.inscricaoService.getInscricaoByUsuarioBySelecaoEmAndamento(this.$store.state.usuario)
                      .then( data => {
                          this.inscricoesEmAndamento = data;
                          this.temInscricoes = data.length > 0;
                      });

      this.inscricaoService.getInscricaoByUsuarioBySelecaoFinalizadas(this.$store.state.usuario)
                      .then( data => {
                        this.inscricoesFinalizadas = data;
                        this.temInscricoesAnteriores = data.length > 0;
                        //console.log(data);
                        //console.log(this.temInscricoesAnteriores);
                      });

    },
  },
};
</script>
